/**
 * @author vishwadeep.kapoor
 */
import COMMON_ENDPOINTS from './commons';

// const PROXY_BASEURL = 'https://admin-dev.zaggle.in/api/v1';
const PROXY_BASEURL = process.env.BASE_PROXY ? `${process.env.BASE_PROXY}api/v1` : 'https://admin-dev.zaggle.in/api/v1';
const PROXY_BASEURL_V3 = process.env.BASE_PROXY ? `${process.env.BASE_PROXY}api/v3` : 'https://admin-dev.zaggle.in/api/v3';
const MOBILE_API_BASEURL = 'https://staging-mobile-api.zaggle.in/api';
const MOBILE_IMAGES_BASEURL = 'https://mobile-api.zaggle.in/images'; /** @desc this will be same in all the @environment */
const PAYMENT_URL = {
  WALLET_PAYU: 'https://test.payu.in/_payment',
  WALLET_MOBIWIK: 'https://test.mobikwik.com/wallet',
};

const CLIENT_SERIES = {
  MANIPAL_SERIES: '0143',
  PROPEL_CORPORATE_GIFTING: '1809',
  LYRA_SERIES: '0048',
};

const CAPTCHA_KEY = '6Lc-ZJEiAAAAAJDxslCafc_tAToATSq6VN1UjezS';

const DEV_ENDPOINTS = {
  ...COMMON_ENDPOINTS({ PROXY_BASEURL, PROXY_BASEURL_V3, MOBILE_API_BASEURL, MOBILE_IMAGES_BASEURL, PAYMENT_URL, CLIENT_SERIES, CAPTCHA_KEY }),
};

export default DEV_ENDPOINTS;



// WEBPACK FOOTER //
// client/config/endPoints/dev.js